// import Footer from "../footer/Footer";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../../../Loading/LoadingSpinner";
import HeaderAds from "../../rent/ads/header/Header";
import Toast from "../../../Modals/toast/Toast";

export default function AdsLayout({ children }) {
  return (
    <>
    <div className="w-screen">
    <Toast></Toast>

      <HeaderAds/>
      <LoadingSpinner></LoadingSpinner>
      <Outlet />
      {/* <Footer /> */}
      </div>
 
    </>
  );
}